import React from "react";
import PropTypes from "prop-types";
const ExternalLinkIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 8 8"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-4-4h16v16H-4z" />
      <g>
        <path d="M0 0h8v8H0z" />
        <rect
          width="6"
          height="2"
          x="2"
          fill={color || "var(--color-easil-gray-x-dark)"}
          rx="1"
        />
        <rect
          width="2"
          height="6"
          x="6"
          fill={color || "var(--color-easil-gray-x-dark)"}
          rx="1"
        />
        <path
          stroke={color || "var(--color-easil-gray-x-dark)"}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M1.012 6.978l5.529-5.625"
        />
      </g>
    </g>
  </svg>
);
ExternalLinkIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default ExternalLinkIcon;
